import { getCustomerDetails } from "@jugl-web/domain-resources/customers/utils";
import { Customer } from "@jugl-web/rest-api";
import { DetailedTask } from "@jugl-web/rest-api/tasks";
import * as yup from "yup";

export const produceUpdateTaskCustomerPayload = (
  customerId: string | null,
  customerObject?: Customer | null
): Partial<DetailedTask> => {
  if (customerId === null || !customerObject) {
    return {
      cust_id: customerId,
    };
  }

  const details = getCustomerDetails(customerObject);

  return {
    cust_id: customerId,
    customer: {
      email: null,
      first_name: details.firstName,
      id: details.id,
      last_name: details.lastName,
      logo: details.avatarUrl,
      phone_number: null,
    },
  };
};

const updateTaskErrorSchema = yup.object({
  data: yup.object({
    errors: yup
      .array(
        yup.object({
          field: yup.string().required(),
          message: yup.string().required(),
        })
      )
      .required(),
  }),
});

export const isUpdateTaskError = (
  error: unknown
): error is yup.InferType<typeof updateTaskErrorSchema> =>
  updateTaskErrorSchema.isValidSync(error);
